<template>
  <div
    class="research_group_container"
    style="background-color: rgba(250, 250, 250, 1)"
  >
    <!-- <base-header :headerName="headerName" @goBack="goBack" /> -->
    <div class="page-progress flex-col">
      <div class="flex-col justify-between">
        <div class="mod4 flex-col">
          <div class="bd1 flex-col">
            <experiment-header :contractNo="contractNo" :status="status" />
            <div style="margin-top: 15px">
              <div
                v-for="(task, index) in taskModules"
                :key="index"
                class="historyProgress"
                style="display:flex"
                :style="task.publishComments.length < 1 ?{height: '19.5vw'}: {}"
              >
                <div style="display: flex;margin-left: 15px;
flex-direction: column;">
                  <div style="line-height: 14px">
                         <!--  结束-->
                    <svg
                    v-if="
                      task.currentStatus ===
                      emkt.EXPERIMENT_MODULES_STATUS_ENDING
                    "
                      class="left1"
                      width="14px"
                      height="14px"
                      viewBox="0 0 14 14"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
                      <title>对勾#merge#</title>
                      <desc>Created with Sketch.</desc>
                      <g
                        id="课题组"
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <g
                          id="进展查询-病毒"
                          transform="translate(-28.000000, -198.000000)"
                          fill="#5878FA"
                          fill-rule="nonzero"
                        >
                          <g
                            id="对勾#merge#"
                            transform="translate(28.000000, 198.000000)"
                          >
                            <path
                              d="M7,0 C3.12083789,0 0,3.12083789 0,7 C0,10.8791621 3.12083789,14 7,14 C10.8791621,14 14,10.8791621 14,7 C14,3.12083789 10.8791621,0 7,0 Z M11.375,5.25 L6.7375,9.8875 L6.73749997,9.88750003 C6.39225641,10.2085075 5.85774352,10.2085075 5.51249997,9.88749997 L2.62499997,6.99999997 C2.62499997,6.99999997 2.18749997,6.56249997 2.62499997,6.12499997 C3.06249997,5.68749997 3.49999997,6.12499997 3.49999997,6.12499997 L6.12499997,8.74999997 L10.5,4.37499997 C10.5,4.37499997 10.9375,3.93749997 11.375,4.37499997 C11.8125,4.81249997 11.375,5.24999997 11.375,5.24999997 L11.375,5.25 Z"
                              id="形状"
                            ></path>
                          </g>
                        </g>
                      </g>
                    </svg>
                   <!--  未开始-->

                    <div class="colorDiv_2 left1"  
                    style="index < taskModules.length -1 ? {'margin': '0 auto'}"
                    v-if="
                      task.currentStatus ===
                        emkt.EXPERIMENT_MODULES_STATUS_CANNOT_START ||
                      task.currentStatus ===
                        emkt.EXPERIMENT_MODULES_STATUS_NOT_START ||
                      task.currentStatus ===
                        emkt.EXPERIMENT_MODULES_STATUS_STOP ||
                      task.currentStatus ===
                        emkt.EXPERIMENT_MODULES_STATUS_READY_START
                    "/>

                   <!--        进行中-->
            <svg
             v-if="task.currentStatus === emkt.EXPERIMENT_MODULES_STATUS_ON_GOING"
              class="left1"
              width="14px"
              height="14px"
              viewBox="0 0 14 14"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
              <title>编组#merge#</title>
              <desc>Created with Sketch.</desc>
              <g
                id="课题组"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  id="进展查询-病毒"
                  transform="translate(-28.000000, -270.000000)"
                >
                  <g
                    id="编组#merge#"
                    transform="translate(28.000000, 270.000000)"
                  >
                    <circle
                      id="椭圆形"
                      fill="#5878FA"
                      cx="7"
                      cy="7"
                      r="7"
                    ></circle>
                    <circle
                      id="椭圆形"
                      fill="#FFFFFF"
                      cx="7"
                      cy="7"
                      r="1"
                    ></circle>
                    <circle
                      id="椭圆形备份"
                      fill="#FFFFFF"
                      cx="9.8"
                      cy="7"
                      r="1"
                    ></circle>
                    <circle
                      id="椭圆形备份-2"
                      fill="#FFFFFF"
                      cx="4.2"
                      cy="7"
                      r="1"
                    ></circle>
                  </g>
                </g>
              </g>
            </svg>
          <!--  终止-->
            <!-- <img
            v-if="task.currentStatus === emkt.EXPERIMENT_MODULES_STATUS_END_STOP"
              class="label8"
              referrerpolicy="no-referrer"
              :src="/static/img/终止.svg"
            /> -->
            <svg 
             v-if="task.currentStatus === emkt.EXPERIMENT_MODULES_STATUS_END_STOP"
             width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>关闭</title>
    <g id="进展查询" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="进展查询-服务类-实验进展备份-2" transform="translate(-25.000000, -306.000000)" fill-rule="nonzero">
            <g id="关闭" transform="translate(25.000000, 306.000000)">
                <path d="M0,7 L0,7 C0,10.8659961 3.13400391,14 7,14 C10.8659961,14 14,10.8659961 14,7 L14,7 C14,3.13400391 10.8659961,0 7,0 C3.13400391,0 0,3.13400391 0,7 L0,7 Z" id="路径" fill="#F55300"></path>
                <path d="M3.2329342,4.3118086 L9.70694355,10.7858173 L9.70694356,10.7858173 C10.0100447,11.0785629 10.4930724,11.0701669 10.7858179,10.7670657 C11.071394,10.4713874 11.071394,10.0026212 10.7858179,9.7069429 L4.31180858,3.23293416 L4.31180861,3.2329342 C4.01906457,2.92983312 3.53603532,2.9214372 3.23293422,3.21418241 C2.92983312,3.50692643 2.9214372,3.98995563 3.21418244,4.29305671 C3.22032389,4.29941542 3.22657539,4.30566692 3.23293407,4.31180834 L3.2329342,4.3118086 Z" id="路径" fill="#F9F9F9"></path>
                <path d="M3.23264301,9.6897523 L9.69864387,3.22344586 L9.69864381,3.22344592 C9.99619785,2.92566646 10.4787993,2.92549677 10.7765646,3.22306477 C11.07433,3.52063287 11.0744997,4.00325708 10.7769458,4.30103654 L4.31018584,10.767343 L4.31018588,10.7673429 C4.01780396,11.0700834 3.53537224,11.0784693 3.23264608,10.7860724 C2.92991991,10.4936767 2.92153438,10.0112221 3.21391749,9.70848168 C3.22005104,9.70213085 3.22629449,9.69588708 3.23264503,9.68975325 L3.23264301,9.6897523 Z" id="路径" fill="#F9F9F9"></path>
            </g>
        </g>
    </g>
</svg>
          </div>

                 <div
                    class="group22"
                    :class="{'div_2':
              task.currentStatus === emkt.EXPERIMENT_MODULES_STATUS_CANNOT_START || task.currentStatus === emkt.EXPERIMENT_MODULES_STATUS_NOT_START
              || task.currentStatus === emkt.EXPERIMENT_MODULES_STATUS_STOP
              || task.currentStatus === emkt.EXPERIMENT_MODULES_STATUS_READY_START
                    }"
                    v-if="index < taskModules.length -1"
                  ></div>

                  </div>

                <div class="progress_history" :style="(task.publishComments.length < 1 || (task.publishComments.length> 0 && task.publishComments[0].length < 50))  ?{height: '91px'}: {}">
                 <div class="box4_text" :style=" (task.currentStatus ===
                              emkt.EXPERIMENT_MODULES_STATUS_CANNOT_START ||
                            task.currentStatus ===
                              emkt.EXPERIMENT_MODULES_STATUS_NOT_START  ||
                            task.currentStatus ===
                              emkt.EXPERIMENT_MODULES_STATUS_STOP ||
                            task.currentStatus ===
                              emkt.EXPERIMENT_MODULES_STATUS_READY_START) ? {'margin-top': '-3px'}: ''">
                    <div
                      class="plasmidExtraction"
                      :class="[
                        task.publishComments.length > 0
                          ? 'color_red'
                          : task.currentStatus !==
                              emkt.EXPERIMENT_MODULES_STATUS_CANNOT_START &&
                            task.currentStatus !==
                              emkt.EXPERIMENT_MODULES_STATUS_NOT_START &&
                            task.currentStatus !==
                              emkt.EXPERIMENT_MODULES_STATUS_STOP &&
                            task.currentStatus !==
                              emkt.EXPERIMENT_MODULES_STATUS_READY_START &&
                            task.currentStatus !==
                              emkt.EXPERIMENT_MODULES_STATUS_END_STOP
                          ? 'color_black'
                          : 'color_gray',
                      ]"
                    >
                      {{ task.taskName }}
                    </div>
                    <div class="outer_2">
                      <span class="completionTime" :lines="undefined">
                        <span
                          v-if="
                            task.currentStatus ===
                              emkt.EXPERIMENT_MODULES_STATUS_ENDING ||
                            task.currentStatus ===
                              emkt.EXPERIMENT_MODULES_STATUS_END_STOP
                          "
                          >完成时间</span
                        >
                        <span
                          v-else-if="
                            task.currentStatus ===
                            emkt.EXPERIMENT_MODULES_STATUS_ON_GOING
                          "
                          class="color_blue"
                          >开始时间</span
                        >
                      </span>
                      <span class="text" :lines="undefined">
                        <span
                          v-if="
                            task.currentStatus ===
                              emkt.EXPERIMENT_MODULES_STATUS_ENDING ||
                            task.currentStatus ===
                              emkt.EXPERIMENT_MODULES_STATUS_END_STOP
                          "
                          >{{ task.actualEnd }}</span
                        >
                        <span
                          v-else-if="
                            task.currentStatus ===
                            emkt.EXPERIMENT_MODULES_STATUS_ON_GOING
                          "
                          class="color_blue"
                          >{{ task.actualStart }}</span
                        >
                      </span>
                    </div>
                  </div>
                  <div
                    class="paragraph1"
                    :class="{
                      'paragraph-font1': index !== 0,
                      'paragraph-font2': index === 0,
                    }"
                    :style="{
                      'margin-left':
                        index === taskModules.length - 1 ? '20px' : '10px',
                    }"
                  >
                    <span
                      class="tasktext"
                      style="margin-top: 5px; display: block"
                      v-for="(text, index) in task.publishComments"
                      :key="index"
                    >
                      {{ text }}
                      <br />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
// import BaseHeader from '@/views_v_2.6/components/BaseHeader'
import ExperimentHeader from '@/views/serviceProgressRefactor/components/ExperimentHeader.vue'
// import emkt from '../../../emkt.js'
export default {
  data () {
    return {
      headerName: '实验详情',
      contractNo: '',
      status: 1,
      taskModules: []
    }
  },
  components: {
    // BaseHeader,
    ExperimentHeader
  },
  created () {
    const { contractNo, status, taskModules } = this.$route.params
    this.contractNo = contractNo
    this.status = status
    this.taskModules = taskModules
  },
  computed: {
    ...mapGetters([
      'isWapp'
    ])
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>
<style>
  .research_group_container {
    overflow-y:scroll;
    overflow-x:hidden;
    /*-webkit-overflow-scrolling:touch;*/
    height:100vh;
  }
  .research_group_container {
    overflow-y:scroll;
    overflow-x:hidden;
    /*-webkit-overflow-scrolling:touch;*/
    height:100vh;
  }
  .historyProgress{
    margin-right: 10px;
  }


  .paragraph-font1{
    overflow-wrap: break-word;
    color: rgba(151, 151, 151, 1);
    font-size: 12px;
    line-height: 17px;
  }

  .paragraph-font2{
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 12px;
    line-height: 20px;
  }
  .progress_history{
    display: flex;
    flex-grow: 1;
    margin-top: -4px;
    flex-direction: column;
    /* margin-left: 20px; */

  }

  .page-progress {
    position: relative;
    /* background-color: rgba(250, 250, 250, 1); */
    background: #FAFAFA;
    overflow: hidden;
    width: 100vw;
    top:1vw;
    /* top: 14.93vw; */
    bottom: 4vw;
    margin-bottom: 10px;
  }




  .mod4 {
    z-index: 2;
    border-radius: 10px;
    border: 0.5px solid rgba(239, 238, 243, 1);
    background-color: rgba(255, 255, 255, 1);
    position: relative;
    margin-top: 10px;
    margin-left: 10px;
    margin-right: 10px;
  }


  .box4 {
    height: 14px;
    margin-left: 20px;
    display: flex;
    flex-direction: row;
  }
  .box4_text {

    display: flex;
    justify-content: space-between;
    margin-left: 10ox;
  }




  .group22 {
    /* width: 1px;
    background: url(./img/SketchPng79a2f345adb4354f7c6e9d905063de31ee490088ce02d9f2e4c56894f82751d8.png)
      100% no-repeat; */
    flex-grow: 1;
    margin-left: 5px;
    border-left-width: 2px;
    border-left-style: solid;
    border-left-color: rgba(88, 120, 250, 1);
    width: 0.8vw;
    margin-right: 5px;
  }
  .group2_heigh {
    margin-top: -5px;
    /* margin-bottom: -5px; */
  }


  .paragraph1 {
    margin-left: 10px;
    display: block;
    margin-bottom: 12px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: normal;
    flex-shrink: initial !important;
  }



  .progress1 {
    margin-left: 4vw;
    margin-top: 1.77vh;
    position: relative;
  }
  .leftDiv {
    position: relative;
    /* height: 15.8vw; */
  }
  /* .left1 {
    position: absolute;
    z-index: 9;
  } */
  .div {
    position: absolute;
    top: 2.67vw;
    left: 1.53vw;
    border-left-width: 2px;
    border-left-style: solid;
    border-left-color: rgba(88, 120, 250, 1);
    width: 0.8vw;
    z-index: 1;
  }
  .exception {
    /* height: 28vw;
    top: 5.2vw; */
    /* border-left-color: rgba(239, 238, 243, 1); */
  }
  .block_3 {
    /* display: flex; */
    position: relative;
    align-items: center;
    /* flex-direction: row;
      justify-content: space-between; */
    margin-top: -28.27vw;
    margin-left: 6.4vw;
    width: 77.27vw;
    height: 28.6vw;
  }
  .block_4 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    /* top: 20vw; */
    /* margin-top: 50px; */
    margin-top: 45px;
  }
  .color_gray {
    color: #979797 !important;
  }
  .color_red {
    color: rgba(254, 101, 77, 1) !important;
  }
  .plasmidExtraction {
    opacity: 1;
    max-width: 42.4vw;
    height: 5.33vw;
    /*overflow: hidden;*/
    /*text-overflow: ellipsis;*/
    line-height: 5.33vw;
    /*white-space: nowrap;*/
    font-size: 3.73vw;
    font-weight: 500;
    color: #424242;
    margin-left: 10px;
  }
  .color_black {
    color: #424242 !important;
  }
  .color_blue {
    color: #5878fa !important;
  }
  .outer_2 {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 5.33vw;
    margin-right: 10px;
  }

  .completionTime {
    opacity: 1;
    margin-right: 2.67vw;
    max-width: 20.8vw;
    height: 5.33vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .text {
    opacity: 1;
    max-width: 31.2vw;
    height: 5.33vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.2vw;
    font-weight: 400;
  }


  .colorDiv_2 {
    margin-left: 0.67vw;
    align-self: center;
    border-radius: 2.13vw;
    background-color: #efeef3;
    width: 2.13vw;
    height: 2.13vw;
    
  }

  .div_2 {
    border-left-color: rgba(239, 238, 243, 1);
    z-index: 1;
  }






  .research_group_container {
    overflow-y: scroll;
    overflow-x: hidden;
    /*-webkit-overflow-scrolling:touch;*/
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;

  }

  .label8 {
    width: 14px;
    height: 14px;
  }

  .tasktext {
    color: rgba(254, 101, 77, 1);
    font-size: 12px;
    line-height: 17px;
    text-align: left;
    margin: 3px 0 0 0px;
  }

  /* body * {

  flex-shrink: 0;
} */

button {
  margin: 0;
  padding: 0;
  border: 1px solid transparent;
  outline: none;
  background-color: transparent;
}
button:active {
  opacity: 0.6;
}
.flex-col {
  display: flex;
  flex-direction: column;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
.justify-start {
  display: flex;
  justify-content: flex-start;
}
.justify-center {
  display: flex;
  justify-content: center;
}
.justify-end {
  display: flex;
  justify-content: flex-end;
}
.justify-evenly {
  display: flex;
  justify-content: space-evenly;
}
.justify-around {
  display: flex;
  justify-content: space-around;
}
.justify-between {
  display: flex;
  justify-content: space-between;
}
.align-start {
  display: flex;
  align-items: flex-start;
}
.align-center {
  display: flex;
  align-items: center;
}
.align-end {
  display: flex;
  align-items: flex-end;
}


</style>



// WEBPACK FOOTER //
// index.vue?42437d05